import React, {useEffect, useState, useCallback} from 'react';
import DataTablesEmployee from './DataTablesEmployee';
import DataTablesEmployeeAdmin from './DataTablesEmployeeAdmin';
import DataTablesTransaction from './DataTablesTransaction';
import DataTablesCompany2 from './DataTablesCompany2';
import {
    ListEmployee,
    createemployee, editemployee,
    deleteemployee,
    uploadexele,
    gettransaction, listorder,
    addcredit, ListCompanyLittle, listuser, getcompanylist
} from "../../../../api/api";
import AuthUserDropdown from "../../../shared/widgets/AuthUserDropdown";
import {useDropzone} from "react-dropzone";
import {Checkbox, Grid, ListItem, Typography} from "@mui/material";
import Button from '@mui/material/Button';
import DatePicker from "react-multi-date-picker"
import Close from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {makeStyles} from '@mui/styles';
import {useNavigate} from "react-router-dom";
import JumboCardQuick from "@jumbo/components/JumboCardQuick";
import {
    Dialog,
    DialogActions,
    TextField,
    DialogContent,
    DialogContentText,
    DialogTitle,
    InputLabel, CircularProgress,
    Select,
    Switch, IconButton
} from "@mui/material";
import Swal from "sweetalert2";
import DndWrapper from "../../extensions/dropzone/components/DndWrapper";
import List from "@mui/material/List";

import Div from "@jumbo/shared/Div";

import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import clsx from "clsx";
import DialogClose from './DialogClose';
import {Pagination, Stack} from "@mui/material";
import PaginationItem from '@mui/material/PaginationItem';

import {
    savecredit,
    savereviewadmin,
    savetypeadmin,
    savereview,
    savecatid,
    savepagenumber,
    savecity,
    savecountmatch,
    saveprovince,
    saveQ,
    savestatus, savestartdate, saveenddate
} from '../../../redux/actions/contactsApp'
import {useDispatch, useSelector} from 'react-redux'
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";

import FormHelperText from "@mui/material/FormHelperText";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import error from "../../../../assets/images/error.png";
import TableCell from "@mui/material/TableCell";
import * as XLSX from "xlsx";
import {saveAs} from "file-saver";
import {currencies} from "../../../shared/widgets/CurrencyCalculator/data";
import {get} from "react-color/lib/helpers";

const images = [
    {
        original: "https://picsum.photos/id/1018/1000/600/",
        thumbnail: "https://picsum.photos/id/1018/250/150/",
    },
    {
        original: "https://picsum.photos/id/1015/1000/600/",
        thumbnail: "https://picsum.photos/id/1015/250/150/",
    },
    {
        original: "https://picsum.photos/id/1019/1000/600/",
        thumbnail: "https://picsum.photos/id/1019/250/150/",
    },
];

let pagesize = 30;
let pagenumber0 = 1;
let typestatus = 0;
let q = "";

let pagesizet = 30;
let pagenumbert = 1;
let qt = "";

const rows = []

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})

function toPersianNum(num, dontTrim) {

    if (num === '') {
        return '';
    }

    var i = 0,

        dontTrim = dontTrim || false,

        num = dontTrim ? num.toString() : num.toString().trim(),
        len = num.length,

        res = '',
        pos,

        persianNumbers = typeof persianNumber == 'undefined' ?
            ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'] :
            persianNumbers;

    for (; i < len; i++)
        if ((pos = persianNumbers[num.charAt(i)]))
            res += pos;
        else
            res += num.charAt(i);

    return res;
};

function formatPriceWithComma(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
    },
    chip: {
        margin: theme.spacing(1),
    },

    input: {
        fontFamily: 'iransans',
        width: '100%',
        height: 50,
        marginTop: 15
    },

    border: {
        fontFamily: 'iransans',
        border: '1px solid rgba(0, 0, 0, 0.23)',
        borderRadius: 10,
        fontSize: 5,
        height: 50,
        paddingLeft: 10,
        paddingRight: 10,
        marginBottom: 0,
        display: 'flex',
        flexDirection: 'row-reverse',
        alignItems: 'center',
        color: 'rgba(0, 0, 0, 0.54)',


    },


    bordererror: {
        fontFamily: 'iransans',
        border: '1px solid red',
        borderRadius: 10,
        fontSize: 5,
        height: 50,
        paddingLeft: 10,
        paddingRight: 10,
        marginBottom: 0,
        display: 'flex',
        flexDirection: 'row-reverse',
        alignItems: 'center',
        color: 'rgba(0, 0, 0, 0.54)',


    },


    inputremove: {

        textAlign: 'right',


        '&:focus': {
            backgroundColor: 'transparent',
            outline: 'none'
        },


    },

    inputremovecenter: {

        textAlign: 'center',
        border: 0,
        outline: 0,
        boxShadow: 'none',
        borderRadius: 0,
        borderBottom: '5px solid #ccc',

        '&:focus': {
            backgroundColor: 'transparent',
            outline: 'none',
            borderColor: '#152e84 !important'
        },


    },

    oncepassword: {


        "&:hover": {
            cursor: 'pointer'
        },

    },

    buttonProgress: {
        color: '#dadada',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative',
    },
    error: {

        marginTop: 5,
        color: 'red',
        fontSize: 10,
        fontFamily: 'iransans'


    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },


}));


function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            style={{padding: 0}}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)}/>}
            icon={<span className={classes.icon}/>}
            {...props}
        />
    );
}

let startlet = '';
let endlet = '';

const DataTables = () => {

        const {
            admin,
            review,
            reviewadmin,
            typeadmin,
            countmatch,
            q,
            status,
            province,
            city,
            catid,
            pagenumber, startdate, enddate
        } = useSelector(({contactsApp}) => contactsApp);
        const [EmployeeList, setEmployeeList] = React.useState([]);
        const [CompanyList, setCompanyList] = React.useState([]);
        const [Loadercompany, setLoaderCompany] = React.useState(false);
        const [TranactionList, setTranactionList] = React.useState([]);
        const [files, setFiles] = React.useState([]);
        const [Loader, setLoader] = React.useState(true);
        const [Loader2, setLoader2] = React.useState(false);
        const [openadd, setOpenadd] = React.useState(false);
        const [openedit, setOpenedit] = React.useState(false);
        const [openexel, setOpenexel] = React.useState(false);
        const [opentransaction, setOpentransaction] = React.useState(false);
        const [loaderbutton, setLoaderButton] = React.useState(false);
        const [loaderdelete, setLoaderdelete] = React.useState(false);
        const [loaderadd, setLoaderadd] = React.useState(false);
        const [loadersend, setLoadersend] = React.useState(false);
        const [opendelete, setOpendelete] = React.useState(false);
        const [loaderdeletedialog, setLoaderdeletedialog] = React.useState(false);
        const [name, setName] = React.useState('');
        const [id, setId] = React.useState('');
        const [family, setFamily] = React.useState('');
        const [nationalid, setNationalid] = React.useState('');
        const [mobile, setMobile] = React.useState('');
        const [personnelcode, setPersonnelcode] = React.useState('');
        const [credit, setCredit] = React.useState('');
        const [credit2, setCredit2] = React.useState('');
        const [credituser, setCredituser] = React.useState('');
        const [creditadd, setCreditadd] = React.useState('');
        const [creditadd2, setCreditadd2] = React.useState('');
        const [typeadd, setTypeadd] = React.useState(1);
        const [countresponse, setCountresponse] = React.useState(0);
        const [count, setCount] = React.useState(0);
        const [isadmin, setIsadmin] = React.useState(false);
        // const [status, setStatus] = React.useState(0);
        const [cityvalue, setCityvalue] = React.useState(city);
        const [provincevalue, setProvincevalue] = React.useState(province);
        const [statusvalue, setStatusvalue] = React.useState(status);
        const [companyid, setCompanyid] = React.useState(0);
        const [catidvalue, setCatidvalue] = React.useState(catid);
        const [matchvalue, setMatchvalue] = React.useState(countmatch);
        const [reviewvalue, setReviewvalue] = React.useState(review);
        const [reviewadminvalue, setReviewadminvalue] = React.useState(reviewadmin);
        const [typeadminvalue, setTypeadminvalue] = React.useState(typeadmin);
        const [pagenumbermain, setPagenumberMain] = React.useState(pagenumber);
        const [startdatevalue, setStartdatevalue] = React.useState(startdate);
        const [enddatevalue, setEnddatevalue] = React.useState(enddate);
        const [orderprice, setOrderprice] = React.useState('');
        const [users, setUsers] = useState([]);
        const [companyidnew, setCompanyidnew] = React.useState(0);
        const [countresponset, setCountresponset] = React.useState(0);
        const [textbutton, setTextbutton] = React.useState('');
        const [description, setDescription] = useState('');
        const [expireddate, setExpireddate] = React.useState('');
        const [amountpos, setAmountpos] = React.useState('');
        const [amountneg, setAmountneg] = React.useState('');
        const [defaultValue, setDefaultValue] = React.useState('');
        const [valueq, setValueq] = React.useState(q);
        const [value, setValue] = React.useState('افزایش اعتبار');
        const dispatch = useDispatch();
        const [switchhpossibility, setSwitchhpossibility] = React.useState(false);
        const [errorname, setErrorname] = useState(false);
        const [helpername, setHelpername] = useState('');
        const [errorfamily, setErrorfamily] = useState(false);
        const [helperfamily, setHelperfamily] = useState('');
        const [errormelli, setErrormelli] = useState(false);
        const [helpermelli, setHelpermelli] = useState('');
        const [errornumber, setErrornumber] = useState(false);
        const [helpernumber, setHelpernumber] = useState('');
        const [errorcode, setErrorcode] = useState(false);
        const [helpercode, setHelpercode] = useState('');
        const [errorcredit, setErrorcredit] = useState(false);
        const [helpercredit, setHelpercredit] = useState('');
        const [adminshow, setAdminshow] = useState(false);
        const [age, setAge] = React.useState(0);
        const [imp, setImp] = useState(false);
        const [helperimp, setHelperimp] = useState('');
        const [provincelist, setProvincelist] = useState([]);
        const [citylist, setCitylist] = useState([]);
        const [valuestart, setValuestart] = useState('')
        const [errorstartdate, setErrorstartdate] = useState(false);
        const [errorenddate, setErrorenddate] = useState(false);
        const [filterStartDate, setFilterStartDate] = useState('')
        const [valueend, setValueend] = useState('')
        const navigate = useNavigate();


        function numberWithCommas(nStr) {


            if (typeof nStr == "number") nStr = nStr.toString();
            nStr = nStr.replace(/\,/g, "");
            let x = nStr.split('.');
            let x1 = x[0];
            let x2 = x.length > 1 ? '.' + x[1] : '';
            var rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2');
            }
            return x1 + x2;


            // return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }


        useEffect(() => {

            getcompanylist(pagenumbermain, valueq, statusvalue)
                .then((response) => {

                    if (response.data.IsAdmin) {
                        setAdminshow(true)
                    } else {
                        setAdminshow(false)
                    }

                    let pg = response.data.Count / pagesize
                    setCount(response.data.Count);
                    setIsadmin(response.data.IsAdmin);
                    // setOrderprice(response.data.OrderPrice)

                    if (pg < 1) {
                        setCountresponse(1)
                    } else {
                        setCountresponse(Math.floor(pg) + 1)
                    }
                    // alert(Math.round(pg) );
                    setEmployeeList(response.data.list)
                    // fillexel(response.data.list)

                    setLoader(false);
                    console.log("admin is" + admin);

                })
                .catch((error) => {
                });

        }, []);


        const onopenedit = (index) => {

            // navigate("/homedetails/" + index.Id);


            // alert(index.id)

            // setErrorname(false);
            // setHelpername('')
            // setErrorfamily(false);
            // setHelperfamily('')
            // setErrormelli(false);
            // setHelpermelli('')
            // setErrornumber(false);
            // setHelpernumber('')
            // setErrorcode(false);
            // setHelpercode('')
            // setErrorcredit(false);
            // setHelpercredit('')
            //
            //
            // setId(index.id);
            // setName(index.name);
            // setFamily(index.family);
            // setNationalid(index.nationalid);
            // setMobile(index.mobile);
            // setPersonnelcode(index.personnelcode)
            // setCredit(index.credit)
            // // alert(index.expireddate);
            // if (index.expireddate == null) {
            //     setExpireddate('')
            // } else {
            //     setExpireddate(index.expireddate)
            // }
            //
            // setOpenedit(true);
            //
            // if (index.active) {
            //     setSwitchhpossibility(true);
            // } else {
            //     setSwitchhpossibility(false);
            // }

        }
        const onopenorder = (index) => {
            // alert(index.id);
            navigate('/orders/' + index.idu);
            // navigate('/ticketdetails/' + x)
        }
        const onopenincome = (index) => {
            navigate('/income/' + index.idu);
        }
        const onopeninvoice = (index) => {
            navigate('/invoice/' + index.idu);
            // navigate('/newinvoice/' + index.id);
        }
        const onopenreport = (index) => {
            navigate('/report/' + index.idu);
        }

        const ontransactionemployeetable = (id0) => {
            setId(id0)
            setOpenedit(false);
            setCreditadd('');
            setDescription('');
            setOpentransaction(true);

        }

        const handleChangePagination = (event, value) => {
            // alert(value);
            setLoader(true);
            // pagenumber = value
            setPagenumberMain(value)
            dispatch(savepagenumber(value))

            getcompanylist(value, valueq, statusvalue)
                .then((response) => {

                    if (response.data.IsAdmin) {
                        setAdminshow(true)
                    } else {
                        setAdminshow(false)
                    }

                    let pg = response.data.Count / pagesize
                    setCount(response.data.Count);
                    setIsadmin(response.data.IsAdmin);
                    // setOrderprice(response.data.OrderPrice)

                    if (pg < 1) {
                        setCountresponse(1)
                    } else {
                        setCountresponse(Math.floor(pg) + 1)
                    }
                    // alert(Math.round(pg) );
                    setEmployeeList(response.data.list)
                    // fillexel(response.data.list)

                    setLoader(false);
                    console.log("admin is" + admin);

                })
                .catch((error) => {
                });


        };

        const onsearchbutton = (e) => {

            setLoader(true);
            setPagenumberMain(1)
            dispatch(savepagenumber(1))

            getcompanylist(1, valueq, statusvalue)
                .then((response) => {

                    if (response.data.IsAdmin) {
                        setAdminshow(true)
                    } else {
                        setAdminshow(false)
                    }

                    let pg = response.data.Count / pagesize
                    setCount(response.data.Count);
                    setIsadmin(response.data.IsAdmin);
                    // setOrderprice(response.data.OrderPrice)

                    if (pg < 1) {
                        setCountresponse(1)
                    } else {
                        setCountresponse(Math.floor(pg) + 1)
                    }
                    // alert(Math.round(pg) );
                    setEmployeeList(response.data.list)
                    // fillexel(response.data.list)

                    setLoader(false);
                    console.log("admin is" + admin);

                })
                .catch((error) => {
                });


        }

        const onsearch = (e) => {
            setValueq(e.target.value);
            console.log(e.target.value);
            dispatch(saveQ(e.target.value))

        }

        const handleChangeSelectStatus = (event) => {
            setStatusvalue(event.target.value)
            dispatch(savestatus(event.target.value))
            setLoader(true);
            setPagenumberMain(1)
            dispatch(savepagenumber(1))
            getcompanylist(1, valueq, event.target.value)
                .then((response) => {

                    let pg = response.data.Count / pagesize
                    setCount(response.data.Count);

                    if (pg < 1) {
                        setCountresponse(1)
                    } else {
                        setCountresponse(Math.floor(pg) + 1)
                    }
                    // alert(Math.round(pg) );


                    setEmployeeList(response.data.list)

                    setLoader(false);
                    console.log("admin is" + admin);

                })
                .catch((error) => {
                });
        }

        return (


            <React.Fragment>

                {/*<div style={{width: '100%', marginBottom: 20, display: 'flex', flexDirection: 'row-reverse'}}>*/}
                {/*    <AuthUserDropdown/>*/}
                {/*</div>*/}


                <div style={{display: 'flex', flexDirection: 'row', marginBottom: 20, width: "100%"}}>
                    <div style={{width: "30%"}}>
                        <div style={{
                            width: "100%",
                            paddingLeft: 20,
                            paddingRight: 20,
                            display: 'flex', justifyContent: 'start', alignItems: 'center',
                            flexDirection: 'row'
                        }}>
                            <div style={{
                                marginLeft: 10,
                                fontSize: 15,
                                fontFamily: 'Iran',
                                fontWeight: 'bold'
                            }}>
                                جستجو
                            </div>
                            <TextField
                                onChange={e => onsearch(e)}
                                autoComplete='off'
                                value={valueq} className='iran-font3'
                                placeholder="جستجو در نام یا شناسه"
                                style={{marginRight: 5, width: '100%', color: '#000'}}
                                id="outlined-basic" variant="outlined" InputLabelProps={{
                                style: {height: 40, width: '100%', color: '#000', fontFamily: 'Iran'},
                                shrink: false,
                            }} InputProps={{
                                style: {
                                    height: 40,
                                    width: '100%',
                                    fontFamily: 'Iran', paddingLeft: 4,
                                    color: '#000'
                                }, endAdornment: <Button onClick={e => onsearchbutton(e)} variant="contained" style={{
                                    padding: 0,
                                    width: 120,
                                    fontSize: 14,
                                    height: 33, fontWeight: 500, borderRadius: 0,

                                    fontFamily: 'Iran'
                                }}
                                                         className="bg-primary text-white"
                                >جستجو</Button>
                            }}
                            />
                        </div>
                    </div>


                    {adminshow ?
                        <div style={{width: "30%"}}>
                            <div style={{
                                width: "100%",
                                paddingLeft: 20,
                                paddingRight: 20,
                                display: 'flex', justifyContent: 'start', alignItems: 'center',
                                flexDirection: 'row'
                            }}>
                                <div style={{
                                    marginLeft: 0,
                                    fontSize: 15,
                                    fontFamily: 'Iran',
                                    fontWeight: 'bold',
                                    width: 100
                                }}>
                                    وضعیت :
                                </div>
                                <FormControl style={{width: 200}}>
                                    {/*<InputLabel style={{ height: 40 }} id="demo-simple-select-label">دلیل</InputLabel>*/}
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={statusvalue}
                                        style={{height: 40, fontFamily: 'Iran'}}
                                        label="وضعیت"
                                        onChange={handleChangeSelectStatus}
                                    >
                                        <MenuItem style={{fontFamily: 'Iran'}} value={0}>همه</MenuItem>
                                        <MenuItem style={{fontFamily: 'Iran'}} value={1}>غیرفعال</MenuItem>
                                        <MenuItem style={{fontFamily: 'Iran'}} value={2}>فعال</MenuItem>

                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                        :
                        null
                    }

                </div>


                <JumboCardQuick
                    // title={'لیست اقامتگاه ها ' + '('  + ')'}
                    title={'لیست شرکت ها ' + '(' + toPersianNum(count) + ')'}
                    wrapperSx={{p: 3}}
                >

                    <div style={{display: 'flex', flexDirection: 'column'}}>

                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'baseline'}}>
                        </div>

                        {Loader ?
                            <div style={{
                                display: 'flex', width: '100%', padding: 50,
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}>
                                <CircularProgress style={{color: '#2a44a1'}} size={24}/>
                            </div>
                            :
                            <div>
                                {adminshow ?
                                    <DataTablesCompany2 EmployeeList={EmployeeList} Loader={Loader}
                                                        onopenedit={onopenedit} onopenincome={onopenincome}
                                                        onopeninvoice={onopeninvoice}
                                                        onopenreport={onopenreport} onopenorder={onopenorder}
                                                        onopentransaction={ontransactionemployeetable}/>
                                    :
                                    <DataTablesCompany2 EmployeeList={EmployeeList} Loader={Loader} onopenedit={onopenedit}
                                                        onopenincome={onopenincome} onopeninvoice={onopeninvoice}
                                                        onopenreport={onopenreport} onopenorder={onopenorder}
                                                        onopentransaction={ontransactionemployeetable}/>
                                }
                            </div>
                        }
                    </div>

                    {countresponse === 1 ?
                        null
                        :
                        <div style={{
                            width: '100%', marginTop: 15, marginBottom: 15,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <Pagination page={pagenumbermain} onChange={handleChangePagination} count={countresponse}
                                        variant="outlined"
                                        color="primary"

                                        renderItem={(item) => (
                                            <PaginationItem
                                                slots={{previous: ArrowForwardIcon, next: ArrowBackIcon}}
                                                {...item}
                                            />
                                        )}
                            />
                        </div>
                    }


                </JumboCardQuick>
            </React.Fragment>
        );
    }
;

export default DataTables;

